import { atom } from 'jotai';

export const qrAtom = atom<boolean>(false);
